import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-filter-input',
  templateUrl: './filter-input.component.html',
  styleUrls: ['./filter-input.component.css']
})
export class FilterInputComponent implements OnInit {
  @Input() width = '15em';
  @Output() changeEvent = new EventEmitter<string>()
  valueControl = new FormControl();

  constructor() { }

  ngOnInit() {
    this.valueControl.valueChanges
      .map((v) => v.trim())
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe((txt) => this.changeEvent.emit(txt))
  }

  

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/filter-input/filter-input.component.ts